interface ITopPair {
  from_code: string
  to_code: string
}

export const TOP_PAIRS: ITopPair[] = [
  { from_code: 'BTC', to_code: 'XMR' },
  { from_code: 'BTC', to_code: 'USDT' },
  { from_code: 'USDT', to_code: 'XMR' },
  { from_code: 'ETH', to_code: 'XMR' },
  { from_code: 'ETH', to_code: 'BTC' },
  { from_code: 'XMR', to_code: 'BTC' },
  { from_code: 'BNB', to_code: 'ETH' },
  { from_code: 'BTC', to_code: 'ETH' },
  { from_code: 'SOL', to_code: 'BTC' },
  { from_code: 'USDT', to_code: 'BTC' },
  { from_code: 'USDT', to_code: 'TRX' },
  { from_code: 'LTC', to_code: 'XMR' },
  { from_code: 'ETH', to_code: 'BNB' },
  { from_code: 'BNB', to_code: 'BTC' },
  { from_code: 'XMR', to_code: 'LTC' },
  { from_code: 'XMR', to_code: 'ETH' },
  { from_code: 'LTC', to_code: 'BTC' },
  { from_code: 'BTC', to_code: 'BNB' },
  { from_code: 'XMR', to_code: 'USDT' },
  { from_code: 'BNB', to_code: 'USDT' },
  { from_code: 'SOL', to_code: 'ETH' },
  { from_code: 'USDT', to_code: 'ETH' },
  { from_code: 'USDT', to_code: 'BNB' },
  { from_code: 'BTC', to_code: 'LTC' },
  { from_code: 'ETH', to_code: 'USDT' },
  { from_code: 'BTC', to_code: 'TRX' },
  { from_code: 'ETH', to_code: 'TRX' },
  { from_code: 'MATIC', to_code: 'BTC' },
  { from_code: 'BTC', to_code: 'SOL' },
]
